export default "__VITE_ASSET__MhxEwiO0__"